// Image asset URLs — production-quality photography
export const IMAGES = {
  hero_parallax: "https://images.unsplash.com/photo-1603635827236-811b622fe53b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  riyadh_night: "https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  macro_eagle: "https://images.unsplash.com/photo-1486122676632-ad1b5681fe33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  saudi_office: "https://images.unsplash.com/photo-1570724546132-6a61bb3c3894?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // fallback business/executive imagery
  boardroom: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  documents: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
